import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BASE_URL, BaseApi } from "@edl-development/edl-common";
import { of } from "rxjs";
import { InComplianceReportRequest } from "../model/in-compliance-report-request.model";

@Injectable()
export class VolunteerReportApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getInComplianceReport(request: InComplianceReportRequest) {
        let params = new HttpParams()
            .append('offset', String(request.Offset))
            .append('limit', String(request.Limit))
            .append('orderBy', String(request.OrderBy))
            .append('ascending', String(request.Ascending))
            .append('searchBy', this.convertParam(request.SearchBy))
            .append('itemPacketId', request.ItemPacketId ? String(request.ItemPacketId) : "")
            .append('volunteerAreaIds', this.convertArrayParam(request.VolunteerAreaIds))
            .append('getAllResults', String(request.GetAllResults));

        if (params.get('itemPacketId') === '' || params.get('itemPacketId') === null) {
            return of({ Results: null });
        }

        return this.http.get(this.baseUri + '/volunteer/report/inCompliance', { params });
    }

    downloadInComplianceReport(request: InComplianceReportRequest) {
        let params = new HttpParams()
            .append('offset', String(request.Offset))
            .append('limit', String(request.Limit))
            .append('orderBy', String(request.OrderBy))
            .append('ascending', String(request.Ascending))
            .append('searchBy', this.convertParam(request.SearchBy))
            .append('itemPacketId', request.ItemPacketId ? String(request.ItemPacketId) : "")
            .append('volunteerAreaIds', this.convertArrayParam(request.VolunteerAreaIds))
            .append('getAllResults', String(request.GetAllResults));
            
        return this.http.get(this.baseUri + '/volunteer/report/inCompliance/download/', {
            params,
            responseType: 'blob'
        })
    }
}